module.exports = __webpack_public_path__ + "img/cave110.27b6af52.jpg";